import { render } from "./DynamicComponent.vue?vue&type=template&id=6eb5ccae"
import script from "./DynamicComponent.vue?vue&type=script&lang=js"
export * from "./DynamicComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DynamicComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6eb5ccae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6eb5ccae', __exports__)) {
    api.reload('6eb5ccae', __exports__)
  }
  
  module.hot.accept("./DynamicComponent.vue?vue&type=template&id=6eb5ccae", () => {
    api.rerender('6eb5ccae', render)
  })

}


export default __exports__